import { OptimizelyContext, useDecision } from '@optimizely/react-sdk';
import { useContext } from 'react';
import { FEATURES } from '../optimizely/enums';

export const useIsRemoteActivationFlowImprovementsEnabled = () => {
  const { optimizely } = useContext(OptimizelyContext);
  const [decision] = useDecision(FEATURES.IsRemoteActivationFlowImprovementsEnabled, {});
  return !!optimizely && decision.enabled;
};
